export default "__VITE_ASSET__WulvxPwF__"